import React, { useState } from 'react';
import { Phone, Search } from 'lucide-react';
import './Catalog.css';
import ProductList from "@/components/client/ProductList/ProductList.js";
import CategoryButton from "@/components/client/CategoryButton/CategoryButton.js";
import { Categories } from "@/data/categories.js";

function Catalog() {
    const [activeCategory, setActiveCategory] = useState(Categories[0].id);
    const [searchTerm, setSearchTerm] = useState("");

    return (
        <div className="app-container">
            <header className="header">
                <div className="brand-section">
                    <div className="logo-placeholder"></div>
                    <div className="brand-info">
                        <h1>Dulce como vos</h1>
                        <p>Café & Helado</p>
                        <span className="phone">
                            <Phone size={26} color='#7C625E' fill='#7C625E' strokeWidth={0}/>
                            +57 315 624 6231
                        </span>
                    </div>
                </div>
            </header>

            <div className="search-container">
                <div className="search-box">
                    <span className="search-icon">
                        <Search size={26} color='#7c625E' strokeWidth={3}/>
                    </span>
                    {/* CORRECCIÓN: Usamos setSearchTerm para actualizar el estado */}
                    <input
                        type="text"
                        placeholder="Buscar milkshakes.."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
            </div>

            <div className="categories">
                {Categories.map((category) => (
                    <CategoryButton
                        key={category.id}
                        category={category}
                        isActive={activeCategory === category.id}
                        onClick={() => setActiveCategory(category.id)}
                    />
                ))}
            </div>

            {/* PASAMOS LOS PROPS: Categoría y Término de búsqueda */}
            <ProductList activeCategory={activeCategory} searchTerm={searchTerm} />
        </div>
    );
}

export default Catalog;